import styled from "styled-components";

export const PageWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(102, 126, 234, 0.5);
    border-radius: 3px;
  }

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const PageTitle = styled.h2`
  font-size: 1.75rem;
  font-weight: 700;
  color: white;
  margin: 0 0 1.5rem 0;
  text-align: center;
`;

export const TableWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  background: white;
  border-radius: 0.75rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  overflow: hidden;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const Thead = styled.thead`
  background: #f9fafb;
  border-bottom: 2px solid #e5e7eb;
`;

export const Tbody = styled.tbody``;

export const Tfoot = styled.tfoot`
  background: #f9fafb;
  border-top: 2px solid #e5e7eb;
`;

export const TotalRow = styled.tr``;

export const TotalLabel = styled.td`
  padding: 1rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 700;
  color: #374151;
  text-align: right;
  colspan: 3;
`;

export const TotalValue = styled.td`
  padding: 1rem 1.25rem;
  font-size: 1rem;
  font-weight: 700;
  color: #667eea;
  text-align: right;
`;

export const Th = styled.th<{ align?: "left" | "right" }>`
  padding: 0.875rem 1.25rem;
  text-align: ${({ align }) => align ?? "left"};
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6b7280;
`;

export const Tr = styled.tr`
  border-bottom: 1px solid #f3f4f6;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #fafafa;
  }
`;

export const Td = styled.td<{ align?: "left" | "right"; bold?: boolean; accent?: boolean }>`
  padding: 1rem 1.25rem;
  font-size: 0.9rem;
  color: ${({ accent }) => (accent ? "#764ba2" : "#374151")};
  text-align: ${({ align }) => align ?? "left"};
  font-weight: ${({ bold }) => (bold ? 600 : 400)};
`;

export const ActionCell = styled.td`
  padding: 0.5rem 1rem;
  text-align: right;
  white-space: nowrap;
`;

export const IconButton = styled.button<{ variant: "edit" | "remove" }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease;
  background: ${({ variant }) =>
    variant === "edit" ? "rgba(102, 126, 234, 0.1)" : "rgba(239, 68, 68, 0.1)"};
  color: ${({ variant }) => (variant === "edit" ? "#667eea" : "#ef4444")};

  & + & {
    margin-left: 0.375rem;
  }

  &:hover {
    background: ${({ variant }) =>
      variant === "edit" ? "rgba(102, 126, 234, 0.2)" : "rgba(239, 68, 68, 0.2)"};
    transform: translateY(-1px);
  }
`;

export const CheckoutBar = styled.div`
  width: 100%;
  max-width: 800px;
  display: flex;
  justify-content: flex-end;
  margin-top: 1.25rem;
`;

export const CheckoutButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.75rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-size: 0.95rem;
  font-weight: 600;
  border: none;
  border-radius: 0.75rem;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  transition: opacity 0.2s ease, transform 0.2s ease;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;
